export var EntityActions = /*#__PURE__*/function (EntityActions) {
  EntityActions["Set"] = "Set";
  EntityActions["Add"] = "Add";
  EntityActions["Update"] = "Update";
  EntityActions["Remove"] = "Remove";
  return EntityActions;
}(EntityActions || {});

